module.exports = __webpack_public_path__ + "img/phone-sc.84335cb7.svg";